import React from "react";
import { useIntl } from "react-intl";

import CustomSelect from "src/app/components/CustomSelect/CustomSelect";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { MaterialTooltip } from "src/app/components/MaterialTooltip/MaterialTooltip";
import getGenders from "./utils/getGenders";

export default function InfluencerGenderSelect({
  selectedInfluencerGender,
  onChangeInfluencerGender,
  isDisabled,
}) {
  const intl = useIntl();
  const genders = getGenders(intl);

  const foundSelectedGenderOption =
    genders.find(
      (gender) => gender.value === selectedInfluencerGender?.value,
    ) ?? null;

  return (
    <div className="audience-search__field" data-qa="filter_influencer_gender">
      <div className="idh-label idh-label--with-tooltip">
        <IDHFormattedMessage id="front_gender" defaultMessage="Gender" />
        <MaterialTooltip
          id="front_influencer_gender_tooltip"
          content={
            <IDHFormattedMessage
              id="front_influencer_gender_tooltip"
              defaultMessage="Here you can specify what influencer gender(s) you are searching for."
            />
          }
        />
      </div>
      <CustomSelect
        placeholder={intl.formatMessage({
          id: "front_select_gender",
          defaultMessage: "Both",
        })}
        isClearable
        value={foundSelectedGenderOption}
        options={genders}
        onChange={(option) => {
          if (option) {
            onChangeInfluencerGender({ value: option.value });
          } else {
            onChangeInfluencerGender(option);
          }
        }}
        isDisabled={isDisabled}
        dataAttr="influencer-gender"
      />
    </div>
  );
}
